module.exports = __webpack_public_path__ + "img/403-error.bef9f532.png";